<template>
    <div id="background">
        <div id="container">
            <div id="header">
                ログイン
            </div>
            <div id="content">
                <div>
                    <label>メール</label><br>
                    <input name="nippo_login_mail" id="nippo_login_mail" />
                </div>
                <div style="margin-top: 20px;">
                    <label>パスワード</label><br>
                    <input name="nippo_login_password" id="nippo_login_password" type="password"/>
                </div>
                <div>
                    <div id="loginbtn" @click="OnSendLoginRequest">
                        ログイン
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    props:{
        SendLoginRequest: Function
    },
    mounted(){
        console.log('show login');
    },
    methods:{
        OnSendLoginRequest()
        {
            this.SendLoginRequest(
                document.getElementById('nippo_login_mail').value,
                document.getElementById('nippo_login_password').value
            );
        }
    }
}
</script>

<style lang="css" scoped>
#background
{
    display: grid;
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: rgba(0,0,0,0.9);
    width: 100vw;
    height: 100vh;
}

#container
{
    place-self: center; background-color: antiquewhite; width: 400px; height: 300px; border-radius: 10px; display: flex; flex-direction: column;
}

#header
{
    background-color: green; border-top-left-radius: 10px; border-top-right-radius: 10px; color: white; font-size: 120%; padding: 10px 0px;
}

#content
{
    display: grid; place-self: center; place-content: center; flex: 1; width: 100%;
}

#loginbtn
{
    margin-top: 20px; background-color: red; color: white; border-radius: 10px; display: inline-block; padding: 5px 10px; cursor: pointer;
}
</style>